import { Directive, ElementRef, HostListener, Input } from '@angular/core'

@Directive({
  selector: '[numbersOnly]',
})
export class NumbersOnlyDirective {
  // allow decimals
  @Input('allowDecimals') allowDecimals = false

  private numberRegex = new RegExp(/^[0-9]+$/)
  private twoDecimalRegex = new RegExp(/^\d*\.?\d{0,2}$/g)
  private allowedSpecialKeys = [
    'Delete',
    'Backspace',
    'Tab',
    'Escape',
    'Enter',
    'NumLock',
    'ArrowLeft',
    'ArrowRight',
    'End',
    'Home',
  ]

  constructor(protected el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.isAllowedSpecialKey(event)) return

    if (!event.key.match(this.numberRegex)) {
      event.preventDefault()
      return
    }

    if (this.allowDecimals) {
      const current = this.el.nativeElement.value
      const next = current.concat(event.key)
      // limit to two decimal places
      if (!next.match(this.twoDecimalRegex)) {
        event.preventDefault()
      }
    }
  }

  private isAllowedSpecialKey(event: KeyboardEvent): boolean {
    return (
      this.allowedSpecialKeys.indexOf(event.key) !== -1 ||
      // allow decimal key if decimals allowed
      (this.allowDecimals && event.key === '.') ||
      // allow Ctrl + V
      (event.key === 'v' && (event.ctrlKey || event.metaKey)) ||
      // allow Ctrl + A
      (event.key === 'a' && (event.ctrlKey || event.metaKey))
    )
  }
}
